import Enumerable from "linq";
import { RecipientSubTypeEnum } from "../../common/enums/RecipientSubTypeEnum";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import { IRecipientEditDTO } from "../../services/recipient-data-service/Models";
import { RecipientEditDialogFormValuesType, RecipientEditDialogInitValues, RecipientEditDialogReturnValues } from "./RecipientEditDialog";
import i18n from "../../services/localization-service/i18n";

export const countries = Enumerable
    .from([
        { code: "AD", name: i18n.t("countries.ad.name"), telephonePrefix: i18n.t("countries.ad.telephonePrefix") },
        { code: "AE", name: i18n.t("countries.ae.name"), telephonePrefix: i18n.t("countries.ae.telephonePrefix") },
        { code: "AF", name: i18n.t("countries.af.name"), telephonePrefix: i18n.t("countries.af.telephonePrefix") },
        { code: "AG", name: i18n.t("countries.ag.name"), telephonePrefix: i18n.t("countries.ag.telephonePrefix") },
        { code: "AI", name: i18n.t("countries.ai.name"), telephonePrefix: i18n.t("countries.ai.telephonePrefix") },
        { code: "AL", name: i18n.t("countries.al.name"), telephonePrefix: i18n.t("countries.al.telephonePrefix") },
        { code: "AM", name: i18n.t("countries.am.name"), telephonePrefix: i18n.t("countries.am.telephonePrefix") },
        { code: "AN", name: i18n.t("countries.an.name"), telephonePrefix: i18n.t("countries.an.telephonePrefix") },
        { code: "AO", name: i18n.t("countries.ao.name"), telephonePrefix: i18n.t("countries.ao.telephonePrefix") },
        { code: "AQ", name: i18n.t("countries.aq.name"), telephonePrefix: i18n.t("countries.aq.telephonePrefix") },
        { code: "AR", name: i18n.t("countries.ar.name"), telephonePrefix: i18n.t("countries.ar.telephonePrefix") },
        { code: "AS", name: i18n.t("countries.as.name"), telephonePrefix: i18n.t("countries.as.telephonePrefix") },
        { code: "AT", name: i18n.t("countries.at.name"), telephonePrefix: i18n.t("countries.at.telephonePrefix") },
        { code: "AU", name: i18n.t("countries.au.name"), telephonePrefix: i18n.t("countries.au.telephonePrefix") },
        { code: "AW", name: i18n.t("countries.aw.name"), telephonePrefix: i18n.t("countries.aw.telephonePrefix") },
        { code: "AZ", name: i18n.t("countries.az.name"), telephonePrefix: i18n.t("countries.az.telephonePrefix") },
        { code: "BA", name: i18n.t("countries.ba.name"), telephonePrefix: i18n.t("countries.ba.telephonePrefix") },
        { code: "BB", name: i18n.t("countries.bb.name"), telephonePrefix: i18n.t("countries.bb.telephonePrefix") },
        { code: "BD", name: i18n.t("countries.bd.name"), telephonePrefix: i18n.t("countries.bd.telephonePrefix") },
        { code: "BE", name: i18n.t("countries.be.name"), telephonePrefix: i18n.t("countries.be.telephonePrefix") },
        { code: "BF", name: i18n.t("countries.bf.name"), telephonePrefix: i18n.t("countries.bf.telephonePrefix") },
        { code: "BG", name: i18n.t("countries.bg.name"), telephonePrefix: i18n.t("countries.bg.telephonePrefix") },
        { code: "BH", name: i18n.t("countries.bh.name"), telephonePrefix: i18n.t("countries.bh.telephonePrefix") },
        { code: "BI", name: i18n.t("countries.bi.name"), telephonePrefix: i18n.t("countries.bi.telephonePrefix") },
        { code: "BJ", name: i18n.t("countries.bj.name"), telephonePrefix: i18n.t("countries.bj.telephonePrefix") },
        { code: "BL", name: i18n.t("countries.bl.name"), telephonePrefix: i18n.t("countries.bl.telephonePrefix") },
        { code: "BM", name: i18n.t("countries.bm.name"), telephonePrefix: i18n.t("countries.bm.telephonePrefix") },
        { code: "BN", name: i18n.t("countries.bn.name"), telephonePrefix: i18n.t("countries.bn.telephonePrefix") },
        { code: "BO", name: i18n.t("countries.bo.name"), telephonePrefix: i18n.t("countries.bo.telephonePrefix") },
        { code: "BS", name: i18n.t("countries.bs.name"), telephonePrefix: i18n.t("countries.bs.telephonePrefix") },
        { code: "BT", name: i18n.t("countries.bt.name"), telephonePrefix: i18n.t("countries.bt.telephonePrefix") },
        { code: "BW", name: i18n.t("countries.bw.name"), telephonePrefix: i18n.t("countries.bw.telephonePrefix") },
        { code: "BY", name: i18n.t("countries.by.name"), telephonePrefix: i18n.t("countries.by.telephonePrefix") },
        { code: "BZ", name: i18n.t("countries.bz.name"), telephonePrefix: i18n.t("countries.bz.telephonePrefix") },
        { code: "CA", name: i18n.t("countries.ca.name"), telephonePrefix: i18n.t("countries.ca.telephonePrefix") },
        { code: "BR", name: i18n.t("countries.br.name"), telephonePrefix: i18n.t("countries.br.telephonePrefix") },
        { code: "CC", name: i18n.t("countries.cc.name"), telephonePrefix: i18n.t("countries.cc.telephonePrefix") },
        { code: "CD", name: i18n.t("countries.cd.name"), telephonePrefix: i18n.t("countries.cd.telephonePrefix") },
        { code: "CF", name: i18n.t("countries.cf.name"), telephonePrefix: i18n.t("countries.cf.telephonePrefix") },
        { code: "CG", name: i18n.t("countries.cg.name"), telephonePrefix: i18n.t("countries.cg.telephonePrefix") },
        { code: "CH", name: i18n.t("countries.ch.name"), telephonePrefix: i18n.t("countries.ch.telephonePrefix") },
        { code: "CI", name: i18n.t("countries.ci.name"), telephonePrefix: i18n.t("countries.ci.telephonePrefix") },
        { code: "CK", name: i18n.t("countries.ck.name"), telephonePrefix: i18n.t("countries.ck.telephonePrefix") },
        { code: "CL", name: i18n.t("countries.cl.name"), telephonePrefix: i18n.t("countries.cl.telephonePrefix") },
        { code: "CM", name: i18n.t("countries.cm.name"), telephonePrefix: i18n.t("countries.cm.telephonePrefix") },
        { code: "CN", name: i18n.t("countries.cn.name"), telephonePrefix: i18n.t("countries.cn.telephonePrefix") },
        { code: "CO", name: i18n.t("countries.co.name"), telephonePrefix: i18n.t("countries.co.telephonePrefix") },
        { code: "CR", name: i18n.t("countries.cr.name"), telephonePrefix: i18n.t("countries.cr.telephonePrefix") },
        { code: "CU", name: i18n.t("countries.cu.name"), telephonePrefix: i18n.t("countries.cu.telephonePrefix") },
        { code: "CV", name: i18n.t("countries.cv.name"), telephonePrefix: i18n.t("countries.cv.telephonePrefix") },
        { code: "CW", name: i18n.t("countries.cw.name"), telephonePrefix: i18n.t("countries.cw.telephonePrefix") },
        { code: "CX", name: i18n.t("countries.cx.name"), telephonePrefix: i18n.t("countries.cx.telephonePrefix") },
        { code: "CY", name: i18n.t("countries.cy.name"), telephonePrefix: i18n.t("countries.cy.telephonePrefix") },
        { code: "CZ", name: i18n.t("countries.cz.name"), telephonePrefix: i18n.t("countries.cz.telephonePrefix") },
        { code: "DE", name: i18n.t("countries.de.name"), telephonePrefix: i18n.t("countries.de.telephonePrefix") },
        { code: "DJ", name: i18n.t("countries.dj.name"), telephonePrefix: i18n.t("countries.dj.telephonePrefix") },
        { code: "DK", name: i18n.t("countries.dk.name"), telephonePrefix: i18n.t("countries.dk.telephonePrefix") },
        { code: "DM", name: i18n.t("countries.dm.name"), telephonePrefix: i18n.t("countries.dm.telephonePrefix") },
        { code: "DO", name: i18n.t("countries.do.name"), telephonePrefix: i18n.t("countries.do.telephonePrefix") },
        { code: "DZ", name: i18n.t("countries.dz.name"), telephonePrefix: i18n.t("countries.dz.telephonePrefix") },
        { code: "EC", name: i18n.t("countries.ec.name"), telephonePrefix: i18n.t("countries.ec.telephonePrefix") },
        { code: "EE", name: i18n.t("countries.ee.name"), telephonePrefix: i18n.t("countries.ee.telephonePrefix") },
        { code: "EG", name: i18n.t("countries.eg.name"), telephonePrefix: i18n.t("countries.eg.telephonePrefix") },
        { code: "EH", name: i18n.t("countries.eh.name"), telephonePrefix: i18n.t("countries.eh.telephonePrefix") },
        { code: "ER", name: i18n.t("countries.er.name"), telephonePrefix: i18n.t("countries.er.telephonePrefix") },
        { code: "ES", name: i18n.t("countries.es.name"), telephonePrefix: i18n.t("countries.es.telephonePrefix") },
        { code: "ET", name: i18n.t("countries.et.name"), telephonePrefix: i18n.t("countries.et.telephonePrefix") },
        { code: "FI", name: i18n.t("countries.fi.name"), telephonePrefix: i18n.t("countries.fi.telephonePrefix") },
        { code: "FJ", name: i18n.t("countries.fj.name"), telephonePrefix: i18n.t("countries.fj.telephonePrefix") },
        { code: "FK", name: i18n.t("countries.fk.name"), telephonePrefix: i18n.t("countries.fk.telephonePrefix") },
        { code: "FM", name: i18n.t("countries.fm.name"), telephonePrefix: i18n.t("countries.fm.telephonePrefix") },
        { code: "FO", name: i18n.t("countries.fo.name"), telephonePrefix: i18n.t("countries.fo.telephonePrefix") },
        { code: "FR", name: i18n.t("countries.fr.name"), telephonePrefix: i18n.t("countries.fr.telephonePrefix") },
        { code: "GA", name: i18n.t("countries.ga.name"), telephonePrefix: i18n.t("countries.ga.telephonePrefix") },
        { code: "GB", name: i18n.t("countries.gb.name"), telephonePrefix: i18n.t("countries.gb.telephonePrefix") },
        { code: "GD", name: i18n.t("countries.gd.name"), telephonePrefix: i18n.t("countries.gd.telephonePrefix") },
        { code: "GE", name: i18n.t("countries.ge.name"), telephonePrefix: i18n.t("countries.ge.telephonePrefix") },
        { code: "GG", name: i18n.t("countries.gg.name"), telephonePrefix: i18n.t("countries.gg.telephonePrefix") },
        { code: "GH", name: i18n.t("countries.gh.name"), telephonePrefix: i18n.t("countries.gh.telephonePrefix") },
        { code: "GI", name: i18n.t("countries.gi.name"), telephonePrefix: i18n.t("countries.gi.telephonePrefix") },
        { code: "GL", name: i18n.t("countries.gl.name"), telephonePrefix: i18n.t("countries.gl.telephonePrefix") },
        { code: "GM", name: i18n.t("countries.gm.name"), telephonePrefix: i18n.t("countries.gm.telephonePrefix") },
        { code: "GN", name: i18n.t("countries.gn.name"), telephonePrefix: i18n.t("countries.gn.telephonePrefix") },
        { code: "GQ", name: i18n.t("countries.gq.name"), telephonePrefix: i18n.t("countries.gq.telephonePrefix") },
        { code: "GR", name: i18n.t("countries.gr.name"), telephonePrefix: i18n.t("countries.gr.telephonePrefix") },
        { code: "GT", name: i18n.t("countries.gt.name"), telephonePrefix: i18n.t("countries.gt.telephonePrefix") },
        { code: "GU", name: i18n.t("countries.gu.name"), telephonePrefix: i18n.t("countries.gu.telephonePrefix") },
        { code: "GW", name: i18n.t("countries.gw.name"), telephonePrefix: i18n.t("countries.gw.telephonePrefix") },
        { code: "GY", name: i18n.t("countries.gy.name"), telephonePrefix: i18n.t("countries.gy.telephonePrefix") },
        { code: "HK", name: i18n.t("countries.hk.name"), telephonePrefix: i18n.t("countries.hk.telephonePrefix") },
        { code: "HN", name: i18n.t("countries.hn.name"), telephonePrefix: i18n.t("countries.hn.telephonePrefix") },
        { code: "HR", name: i18n.t("countries.hr.name"), telephonePrefix: i18n.t("countries.hr.telephonePrefix") },
        { code: "HT", name: i18n.t("countries.ht.name"), telephonePrefix: i18n.t("countries.ht.telephonePrefix") },
        { code: "HU", name: i18n.t("countries.hu.name"), telephonePrefix: i18n.t("countries.hu.telephonePrefix") },
        { code: "ID", name: i18n.t("countries.id.name"), telephonePrefix: i18n.t("countries.id.telephonePrefix") },
        { code: "IE", name: i18n.t("countries.ie.name"), telephonePrefix: i18n.t("countries.ie.telephonePrefix") },
        { code: "IL", name: i18n.t("countries.il.name"), telephonePrefix: i18n.t("countries.il.telephonePrefix") },
        { code: "IM", name: i18n.t("countries.im.name"), telephonePrefix: i18n.t("countries.im.telephonePrefix") },
        { code: "IN", name: i18n.t("countries.in.name"), telephonePrefix: i18n.t("countries.in.telephonePrefix") },
        { code: "IO", name: i18n.t("countries.io.name"), telephonePrefix: i18n.t("countries.io.telephonePrefix") },
        { code: "IQ", name: i18n.t("countries.iq.name"), telephonePrefix: i18n.t("countries.iq.telephonePrefix") },
        { code: "IR", name: i18n.t("countries.ir.name"), telephonePrefix: i18n.t("countries.ir.telephonePrefix") },
        { code: "IS", name: i18n.t("countries.is.name"), telephonePrefix: i18n.t("countries.is.telephonePrefix") },
        { code: "IT", name: i18n.t("countries.it.name"), telephonePrefix: i18n.t("countries.it.telephonePrefix") },
        { code: "JE", name: i18n.t("countries.je.name"), telephonePrefix: i18n.t("countries.je.telephonePrefix") },
        { code: "JM", name: i18n.t("countries.jm.name"), telephonePrefix: i18n.t("countries.jm.telephonePrefix") },
        { code: "JO", name: i18n.t("countries.jo.name"), telephonePrefix: i18n.t("countries.jo.telephonePrefix") },
        { code: "JP", name: i18n.t("countries.jp.name"), telephonePrefix: i18n.t("countries.jp.telephonePrefix") },
        { code: "KE", name: i18n.t("countries.ke.name"), telephonePrefix: i18n.t("countries.ke.telephonePrefix") },
        { code: "KG", name: i18n.t("countries.kg.name"), telephonePrefix: i18n.t("countries.kg.telephonePrefix") },
        { code: "KH", name: i18n.t("countries.kh.name"), telephonePrefix: i18n.t("countries.kh.telephonePrefix") },
        { code: "KI", name: i18n.t("countries.ki.name"), telephonePrefix: i18n.t("countries.ki.telephonePrefix") },
        { code: "KM", name: i18n.t("countries.km.name"), telephonePrefix: i18n.t("countries.km.telephonePrefix") },
        { code: "KN", name: i18n.t("countries.kn.name"), telephonePrefix: i18n.t("countries.kn.telephonePrefix") },
        { code: "KP", name: i18n.t("countries.kp.name"), telephonePrefix: i18n.t("countries.kp.telephonePrefix") },
        { code: "KR", name: i18n.t("countries.kr.name"), telephonePrefix: i18n.t("countries.kr.telephonePrefix") },
        { code: "KW", name: i18n.t("countries.kw.name"), telephonePrefix: i18n.t("countries.kw.telephonePrefix") },
        { code: "KY", name: i18n.t("countries.ky.name"), telephonePrefix: i18n.t("countries.ky.telephonePrefix") },
        { code: "KZ", name: i18n.t("countries.kz.name"), telephonePrefix: i18n.t("countries.kz.telephonePrefix") },
        { code: "LA", name: i18n.t("countries.la.name"), telephonePrefix: i18n.t("countries.la.telephonePrefix") },
        { code: "LB", name: i18n.t("countries.lb.name"), telephonePrefix: i18n.t("countries.lb.telephonePrefix") },
        { code: "LC", name: i18n.t("countries.lc.name"), telephonePrefix: i18n.t("countries.lc.telephonePrefix") },
        { code: "LI", name: i18n.t("countries.li.name"), telephonePrefix: i18n.t("countries.li.telephonePrefix") },
        { code: "LK", name: i18n.t("countries.lk.name"), telephonePrefix: i18n.t("countries.lk.telephonePrefix") },
        { code: "LR", name: i18n.t("countries.lr.name"), telephonePrefix: i18n.t("countries.lr.telephonePrefix") },
        { code: "LS", name: i18n.t("countries.ls.name"), telephonePrefix: i18n.t("countries.ls.telephonePrefix") },
        { code: "LT", name: i18n.t("countries.lt.name"), telephonePrefix: i18n.t("countries.lt.telephonePrefix") },
        { code: "LU", name: i18n.t("countries.lu.name"), telephonePrefix: i18n.t("countries.lu.telephonePrefix") },
        { code: "LV", name: i18n.t("countries.lv.name"), telephonePrefix: i18n.t("countries.lv.telephonePrefix") },
        { code: "LY", name: i18n.t("countries.ly.name"), telephonePrefix: i18n.t("countries.ly.telephonePrefix") },
        { code: "MA", name: i18n.t("countries.ma.name"), telephonePrefix: i18n.t("countries.ma.telephonePrefix") },
        { code: "MC", name: i18n.t("countries.mc.name"), telephonePrefix: i18n.t("countries.mc.telephonePrefix") },
        { code: "MD", name: i18n.t("countries.md.name"), telephonePrefix: i18n.t("countries.md.telephonePrefix") },
        { code: "ME", name: i18n.t("countries.me.name"), telephonePrefix: i18n.t("countries.me.telephonePrefix") },
        { code: "MF", name: i18n.t("countries.mf.name"), telephonePrefix: i18n.t("countries.mf.telephonePrefix") },
        { code: "MG", name: i18n.t("countries.mg.name"), telephonePrefix: i18n.t("countries.mg.telephonePrefix") },
        { code: "MH", name: i18n.t("countries.mh.name"), telephonePrefix: i18n.t("countries.mh.telephonePrefix") },
        { code: "MK", name: i18n.t("countries.mk.name"), telephonePrefix: i18n.t("countries.mk.telephonePrefix") },
        { code: "ML", name: i18n.t("countries.ml.name"), telephonePrefix: i18n.t("countries.ml.telephonePrefix") },
        { code: "MM", name: i18n.t("countries.mm.name"), telephonePrefix: i18n.t("countries.mm.telephonePrefix") },
        { code: "MN", name: i18n.t("countries.mn.name"), telephonePrefix: i18n.t("countries.mn.telephonePrefix") },
        { code: "MO", name: i18n.t("countries.mo.name"), telephonePrefix: i18n.t("countries.mo.telephonePrefix") },
        { code: "MP", name: i18n.t("countries.mp.name"), telephonePrefix: i18n.t("countries.mp.telephonePrefix") },
        { code: "MR", name: i18n.t("countries.mr.name"), telephonePrefix: i18n.t("countries.mr.telephonePrefix") },
        { code: "MS", name: i18n.t("countries.ms.name"), telephonePrefix: i18n.t("countries.ms.telephonePrefix") },
        { code: "MT", name: i18n.t("countries.mt.name"), telephonePrefix: i18n.t("countries.mt.telephonePrefix") },
        { code: "MU", name: i18n.t("countries.mu.name"), telephonePrefix: i18n.t("countries.mu.telephonePrefix") },
        { code: "MV", name: i18n.t("countries.mv.name"), telephonePrefix: i18n.t("countries.mv.telephonePrefix") },
        { code: "MW", name: i18n.t("countries.mw.name"), telephonePrefix: i18n.t("countries.mw.telephonePrefix") },
        { code: "MX", name: i18n.t("countries.mx.name"), telephonePrefix: i18n.t("countries.mx.telephonePrefix") },
        { code: "MY", name: i18n.t("countries.my.name"), telephonePrefix: i18n.t("countries.my.telephonePrefix") },
        { code: "MZ", name: i18n.t("countries.mz.name"), telephonePrefix: i18n.t("countries.mz.telephonePrefix") },
        { code: "NA", name: i18n.t("countries.na.name"), telephonePrefix: i18n.t("countries.na.telephonePrefix") },
        { code: "NC", name: i18n.t("countries.nc.name"), telephonePrefix: i18n.t("countries.nc.telephonePrefix") },
        { code: "NE", name: i18n.t("countries.ne.name"), telephonePrefix: i18n.t("countries.ne.telephonePrefix") },
        { code: "NG", name: i18n.t("countries.ng.name"), telephonePrefix: i18n.t("countries.ng.telephonePrefix") },
        { code: "NI", name: i18n.t("countries.ni.name"), telephonePrefix: i18n.t("countries.ni.telephonePrefix") },
        { code: "NL", name: i18n.t("countries.nl.name"), telephonePrefix: i18n.t("countries.nl.telephonePrefix") },
        { code: "NO", name: i18n.t("countries.no.name"), telephonePrefix: i18n.t("countries.no.telephonePrefix") },
        { code: "NP", name: i18n.t("countries.np.name"), telephonePrefix: i18n.t("countries.np.telephonePrefix") },
        { code: "NR", name: i18n.t("countries.nr.name"), telephonePrefix: i18n.t("countries.nr.telephonePrefix") },
        { code: "NU", name: i18n.t("countries.nu.name"), telephonePrefix: i18n.t("countries.nu.telephonePrefix") },
        { code: "NZ", name: i18n.t("countries.nz.name"), telephonePrefix: i18n.t("countries.nz.telephonePrefix") },
        { code: "OM", name: i18n.t("countries.om.name"), telephonePrefix: i18n.t("countries.om.telephonePrefix") },
        { code: "PA", name: i18n.t("countries.pa.name"), telephonePrefix: i18n.t("countries.pa.telephonePrefix") },
        { code: "PE", name: i18n.t("countries.pe.name"), telephonePrefix: i18n.t("countries.pe.telephonePrefix") },
        { code: "PF", name: i18n.t("countries.pf.name"), telephonePrefix: i18n.t("countries.pf.telephonePrefix") },
        { code: "PG", name: i18n.t("countries.pg.name"), telephonePrefix: i18n.t("countries.pg.telephonePrefix") },
        { code: "PH", name: i18n.t("countries.ph.name"), telephonePrefix: i18n.t("countries.ph.telephonePrefix") },
        { code: "PK", name: i18n.t("countries.pk.name"), telephonePrefix: i18n.t("countries.pk.telephonePrefix") },
        { code: "PL", name: i18n.t("countries.pl.name"), telephonePrefix: i18n.t("countries.pl.telephonePrefix") },
        { code: "PM", name: i18n.t("countries.pm.name"), telephonePrefix: i18n.t("countries.pm.telephonePrefix") },
        { code: "PN", name: i18n.t("countries.pn.name"), telephonePrefix: i18n.t("countries.pn.telephonePrefix") },
        { code: "PR", name: i18n.t("countries.pr.name"), telephonePrefix: i18n.t("countries.pr.telephonePrefix") },
        { code: "PS", name: i18n.t("countries.ps.name"), telephonePrefix: i18n.t("countries.ps.telephonePrefix") },
        { code: "PT", name: i18n.t("countries.pt.name"), telephonePrefix: i18n.t("countries.pt.telephonePrefix") },
        { code: "PW", name: i18n.t("countries.pw.name"), telephonePrefix: i18n.t("countries.pw.telephonePrefix") },
        { code: "PY", name: i18n.t("countries.py.name"), telephonePrefix: i18n.t("countries.py.telephonePrefix") },
        { code: "QA", name: i18n.t("countries.qa.name"), telephonePrefix: i18n.t("countries.qa.telephonePrefix") },
        { code: "RE", name: i18n.t("countries.re.name"), telephonePrefix: i18n.t("countries.re.telephonePrefix") },
        { code: "RO", name: i18n.t("countries.ro.name"), telephonePrefix: i18n.t("countries.ro.telephonePrefix") },
        { code: "RS", name: i18n.t("countries.rs.name"), telephonePrefix: i18n.t("countries.rs.telephonePrefix") },
        { code: "RU", name: i18n.t("countries.ru.name"), telephonePrefix: i18n.t("countries.ru.telephonePrefix") },
        { code: "RW", name: i18n.t("countries.rw.name"), telephonePrefix: i18n.t("countries.rw.telephonePrefix") },
        { code: "SA", name: i18n.t("countries.sa.name"), telephonePrefix: i18n.t("countries.sa.telephonePrefix") },
        { code: "SB", name: i18n.t("countries.sb.name"), telephonePrefix: i18n.t("countries.sb.telephonePrefix") },
        { code: "SC", name: i18n.t("countries.sc.name"), telephonePrefix: i18n.t("countries.sc.telephonePrefix") },
        { code: "SD", name: i18n.t("countries.sd.name"), telephonePrefix: i18n.t("countries.sd.telephonePrefix") },
        { code: "SE", name: i18n.t("countries.se.name"), telephonePrefix: i18n.t("countries.se.telephonePrefix") },
        { code: "SG", name: i18n.t("countries.sg.name"), telephonePrefix: i18n.t("countries.sg.telephonePrefix") },
        { code: "SH", name: i18n.t("countries.sh.name"), telephonePrefix: i18n.t("countries.sh.telephonePrefix") },
        { code: "SI", name: i18n.t("countries.si.name"), telephonePrefix: i18n.t("countries.si.telephonePrefix") },
        { code: "SJ", name: i18n.t("countries.sj.name"), telephonePrefix: i18n.t("countries.sj.telephonePrefix") },
        { code: "SK", name: i18n.t("countries.sk.name"), telephonePrefix: i18n.t("countries.sk.telephonePrefix") },
        { code: "SL", name: i18n.t("countries.sl.name"), telephonePrefix: i18n.t("countries.sl.telephonePrefix") },
        { code: "SM", name: i18n.t("countries.sm.name"), telephonePrefix: i18n.t("countries.sm.telephonePrefix") },
        { code: "SN", name: i18n.t("countries.sn.name"), telephonePrefix: i18n.t("countries.sn.telephonePrefix") },
        { code: "SO", name: i18n.t("countries.so.name"), telephonePrefix: i18n.t("countries.so.telephonePrefix") },
        { code: "SR", name: i18n.t("countries.sr.name"), telephonePrefix: i18n.t("countries.sr.telephonePrefix") },
        { code: "SS", name: i18n.t("countries.ss.name"), telephonePrefix: i18n.t("countries.ss.telephonePrefix") },
        { code: "ST", name: i18n.t("countries.st.name"), telephonePrefix: i18n.t("countries.st.telephonePrefix") },
        { code: "SV", name: i18n.t("countries.sv.name"), telephonePrefix: i18n.t("countries.sv.telephonePrefix") },
        { code: "SX", name: i18n.t("countries.sx.name"), telephonePrefix: i18n.t("countries.sx.telephonePrefix") },
        { code: "SY", name: i18n.t("countries.sy.name"), telephonePrefix: i18n.t("countries.sy.telephonePrefix") },
        { code: "SZ", name: i18n.t("countries.sz.name"), telephonePrefix: i18n.t("countries.sz.telephonePrefix") },
        { code: "TC", name: i18n.t("countries.tc.name"), telephonePrefix: i18n.t("countries.tc.telephonePrefix") },
        { code: "TD", name: i18n.t("countries.td.name"), telephonePrefix: i18n.t("countries.td.telephonePrefix") },
        { code: "TG", name: i18n.t("countries.tg.name"), telephonePrefix: i18n.t("countries.tg.telephonePrefix") },
        { code: "TH", name: i18n.t("countries.th.name"), telephonePrefix: i18n.t("countries.th.telephonePrefix") },
        { code: "TJ", name: i18n.t("countries.tj.name"), telephonePrefix: i18n.t("countries.tj.telephonePrefix") },
        { code: "TK", name: i18n.t("countries.tk.name"), telephonePrefix: i18n.t("countries.tk.telephonePrefix") },
        { code: "TL", name: i18n.t("countries.tl.name"), telephonePrefix: i18n.t("countries.tl.telephonePrefix") },
        { code: "TM", name: i18n.t("countries.tm.name"), telephonePrefix: i18n.t("countries.tm.telephonePrefix") },
        { code: "TN", name: i18n.t("countries.tn.name"), telephonePrefix: i18n.t("countries.tn.telephonePrefix") },
        { code: "TO", name: i18n.t("countries.to.name"), telephonePrefix: i18n.t("countries.to.telephonePrefix") },
        { code: "TR", name: i18n.t("countries.tr.name"), telephonePrefix: i18n.t("countries.tr.telephonePrefix") },
        { code: "TT", name: i18n.t("countries.tt.name"), telephonePrefix: i18n.t("countries.tt.telephonePrefix") },
        { code: "TV", name: i18n.t("countries.tv.name"), telephonePrefix: i18n.t("countries.tv.telephonePrefix") },
        { code: "TW", name: i18n.t("countries.tw.name"), telephonePrefix: i18n.t("countries.tw.telephonePrefix") },
        { code: "TZ", name: i18n.t("countries.tz.name"), telephonePrefix: i18n.t("countries.tz.telephonePrefix") },
        { code: "UA", name: i18n.t("countries.ua.name"), telephonePrefix: i18n.t("countries.ua.telephonePrefix") },
        { code: "UG", name: i18n.t("countries.ug.name"), telephonePrefix: i18n.t("countries.ug.telephonePrefix") },
        { code: "US", name: i18n.t("countries.us.name"), telephonePrefix: i18n.t("countries.us.telephonePrefix") },
        { code: "UY", name: i18n.t("countries.uy.name"), telephonePrefix: i18n.t("countries.uy.telephonePrefix") },
        { code: "UZ", name: i18n.t("countries.uz.name"), telephonePrefix: i18n.t("countries.uz.telephonePrefix") },
        { code: "VA", name: i18n.t("countries.va.name"), telephonePrefix: i18n.t("countries.va.telephonePrefix") },
        { code: "VC", name: i18n.t("countries.vc.name"), telephonePrefix: i18n.t("countries.vc.telephonePrefix") },
        { code: "VE", name: i18n.t("countries.ve.name"), telephonePrefix: i18n.t("countries.ve.telephonePrefix") },
        { code: "VG", name: i18n.t("countries.vg.name"), telephonePrefix: i18n.t("countries.vg.telephonePrefix") },
        { code: "VI", name: i18n.t("countries.vi.name"), telephonePrefix: i18n.t("countries.vi.telephonePrefix") },
        { code: "VN", name: i18n.t("countries.vn.name"), telephonePrefix: i18n.t("countries.vn.telephonePrefix") },
        { code: "VU", name: i18n.t("countries.vu.name"), telephonePrefix: i18n.t("countries.vu.telephonePrefix") },
        { code: "WF", name: i18n.t("countries.wf.name"), telephonePrefix: i18n.t("countries.wf.telephonePrefix") },
        { code: "WS", name: i18n.t("countries.ws.name"), telephonePrefix: i18n.t("countries.ws.telephonePrefix") },
        { code: "XK", name: i18n.t("countries.xk.name"), telephonePrefix: i18n.t("countries.xk.telephonePrefix") },
        { code: "YE", name: i18n.t("countries.ye.name"), telephonePrefix: i18n.t("countries.ye.telephonePrefix") },
        { code: "YT", name: i18n.t("countries.yt.name"), telephonePrefix: i18n.t("countries.yt.telephonePrefix") },
        { code: "ZA", name: i18n.t("countries.za.name"), telephonePrefix: i18n.t("countries.za.telephonePrefix") },
        { code: "ZM", name: i18n.t("countries.zm.name"), telephonePrefix: i18n.t("countries.zm.telephonePrefix") },
        { code: "ZW", name: i18n.t("countries.zw.name"), telephonePrefix: i18n.t("countries.zw.telephonePrefix") }
    ])
    .orderBy(o => o.name)
    .toArray();

export const recipientTypes = [
    { id: RecipientTypeEnum.Email, name: i18n.t("enums.recipientType.email") },
    { id: RecipientTypeEnum.Text, name: i18n.t("enums.recipientType.text") },
    { id: RecipientTypeEnum.Voice, name: i18n.t("enums.recipientType.voice") }
];

export const recipientSubTypes = [
    { id: RecipientSubTypeEnum.Cell, name: i18n.t("enums.recipientSubType.cell") },
    { id: RecipientSubTypeEnum.Day, name: i18n.t("enums.recipientSubType.day") },
    { id: RecipientSubTypeEnum.Fax, name: i18n.t("enums.recipientSubType.fax") },
    { id: RecipientSubTypeEnum.Home, name: i18n.t("enums.recipientSubType.home") },
    { id: RecipientSubTypeEnum.Night, name: i18n.t("enums.recipientSubType.night") },
    { id: RecipientSubTypeEnum.Work, name: i18n.t("enums.recipientSubType.work") }
];

export function toReturnValues(recipient: RecipientEditDialogFormValuesType): RecipientEditDialogReturnValues {

    if (recipient.type === RecipientTypeEnum.Email) {
        return {
            recipientID: recipient.id,
            recipientType: recipient.type,
            recipientSubType: recipient.subType,
            recipientTo: recipient.emailAddress ?? "",
            userID: recipient.linkedRecipientUserID,
            userFirstName: recipient.userFirstName,
            userLastName: recipient.userLastName,
            cloneRecipientID: recipient.cloneRecipientUsage
                ? recipient.cloneRecipientID
                : undefined
        };

    } else {

        const country = countries.find(c => c.code === recipient.countryCode);
        const to = `+${country?.telephonePrefix ?? 1} ${recipient.phoneNumber?.replace(/\D/g, "")}`;

        return {
            recipientID: recipient.id,
            recipientType: recipient.type,
            recipientSubType: recipient.subType,
            recipientTo: to,
            userID: recipient.linkedRecipientUserID,
            userFirstName: recipient.userFirstName,
            userLastName: recipient.userLastName,
            cloneRecipientID: recipient.cloneRecipientUsage
                ? recipient.cloneRecipientID
                : undefined
        };
    }
}

export function toFormValuesType(recipient: RecipientEditDialogInitValues): RecipientEditDialogFormValuesType {

    if (recipient.recipientType === RecipientTypeEnum.Email) {
        return {
            id: recipient.recipientID,
            type: recipient.recipientType,
            subType: RecipientSubTypeEnum.None,
            emailAddress: recipient.recipientTo,
            countryCode: "",
            phoneNumber: "",
            cloneRecipientUsage: (recipient.cloneRecipientID??-1) > -1,
            cloneRecipientID: recipient.cloneRecipientID,
            linkToRecipientUser: false,
            linkedRecipientUserID: -1,
            userFirstName: '',
            userLastName: ''
        };
    } else {

        const { phoneNumber, phonePrefix } = parsePhoneParts(recipient.recipientTo, recipient.recipientType);
        let countryCode: string = "US";

        if (recipient.recipientType === RecipientTypeEnum.Text && phonePrefix !== "1") {

            const country = Enumerable
                .from(countries)
                .firstOrDefault(c => c.telephonePrefix === phonePrefix);

            if (country) {
                countryCode = country.code;
            }
        }

        return {
            id: recipient.recipientID,
            type: recipient.recipientType,
            subType: recipient.recipientSubType,
            emailAddress: "",
            countryCode: countryCode,
            phoneNumber: phoneNumber,
            cloneRecipientUsage: (recipient.cloneRecipientID??-1) > -1,
            cloneRecipientID: recipient.cloneRecipientID,
            linkToRecipientUser: false,
            linkedRecipientUserID: -1,
            userFirstName: '',
            userLastName: ''

        };
    }
}

export function parsePhoneParts(recipientTo: string | undefined, recipientType: RecipientTypeEnum | undefined): { phoneNumber: string | undefined; phonePrefix: string | undefined; } {

    let phoneNumber: string | undefined;
    let phonePrefix: string | undefined;

    if (recipientTo && recipientType) {
        if (recipientTo.charAt(0) === "+") {
            const split = recipientTo.split(' ');

            // Only text types can have international phone numbers
            phonePrefix = (recipientType === RecipientTypeEnum.Text)
                ? split[0].replace(/\D/g, "")
                : "1";

            phoneNumber = split[1].replace(/\D/g, "");

        } else if (recipientTo.charAt(0) === "1") {
            phonePrefix = "1";
            phoneNumber = recipientTo.replace(/\D/g, "").substring(1);
        } else {
            phonePrefix = "1";
            phoneNumber = recipientTo.replace(/\D/g, "");
        }

        phoneNumber = (phoneNumber.length > 10)
            ? phoneNumber.substring(0, 10)
            : phoneNumber;
    }

    return { phoneNumber: phoneNumber, phonePrefix: phonePrefix };
}

export function toCheckRecipientParams(fields: RecipientEditDialogFormValuesType): IRecipientEditDTO {

    return {
        recipientID: Number(fields.id),
        recipientType: getRecipientType(fields),
        recipientSubType: getRecipientSubType(fields),
        recipientTo: getRecipientTo(fields),
        userID: 0,
        userFirstName: '',
        userLastName: ''
    };
}

function getRecipientType(fields: RecipientEditDialogFormValuesType): RecipientTypeEnum {

    return (Number.isFinite(fields.type))
        ? Number(fields.type) as RecipientTypeEnum
        : RecipientTypeEnum.Email;
}

function getRecipientSubType(fields: RecipientEditDialogFormValuesType): RecipientSubTypeEnum | undefined {

    const recipientType = getRecipientType(fields);

    if (recipientType !== RecipientTypeEnum.Email) {

        return (Number.isFinite(fields.subType))
            ? Number(fields.subType) as RecipientSubTypeEnum
            : RecipientSubTypeEnum.Cell;
    }
    else {
        return undefined;
    }
}

function getRecipientTo(fields: RecipientEditDialogFormValuesType): string | undefined {

    const recipientType = getRecipientType(fields);

    if (recipientType !== RecipientTypeEnum.Email) {

        return (fields.phoneNumber && (fields.phoneNumber.trim().length > 0))
            ? fields.phoneNumber.trim()
            : undefined;
    }
    else {

        return (fields.emailAddress && (fields.emailAddress.trim().length > 0))
            ? fields.emailAddress.trim()
            : undefined;
    }
}


// function getTelephonePrefix(fields: RecipientEditDialogFormValuesType): string | undefined {

//     const recipientType = _getRecipientType(fields);

//     switch (recipientType) {

//         case RecipientTypeEnum.Text:
//             return ((fields.recipientTelephonePrefix !== null) && (fields.recipientTelephonePrefix.length > 0))
//                 ? fields.recipientTelephonePrefix.trim()
//                 : "1";

//         case RecipientTypeEnum.Voice:
//             return "1";

//         default:
//             return undefined;

//     }

// }

// function getUserFirstName(fields: RecipientEditDialogFormValuesType): string | undefined{

//     if (fields.userId < 0) {

//         return ((fields.userFirstName !== null) && (fields.userFirstName.trim().length > 0))
//             ? fields.userFirstName.trim()
//             : null;

//     }
//     else {
//         return undefined;

//     }
// }

// function getUserLastName(fields: RecipientEditDialogFormValuesType): string | undefined {

//     if (fields.userId < 0) {

//         return ((fields.userLastName !== null) && (fields.userLastName.trim().length > 0))
//             ? fields.userLastName.trim()
//             : null;

//     }
//     else {
//         return undefined;

//     }
// }